import type { AlpineComponent } from 'alpinejs';

export const preselectedAttribute: AlpineComponent = {
	value: 0
};
